import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import includes from 'lodash/includes';
import { setSelectedMetrics, setAppliedSort } from '@store/metricLens/base/actions';
import { supportedMetricsSelector } from '@store/common/selectors';
import { selectedMetricsSelector, appliedSortSelector } from '@store/metricLens/base/selectors';
import { MetricSelectorPopup } from '@src/components/common';
import { track } from '@utils';
import { CLICK_ML_METRICS_CHANGE } from '@src/utils/sensor/track';
import { DropdownWrapper } from '../styled';

const MetricsDropDown = () => {
  const dispatch = useDispatch();
  const selectedMetrics = useSelector(selectedMetricsSelector);
  const appliedSort = useSelector(appliedSortSelector);
  const supportedMetrics = useSelector(supportedMetricsSelector);

  const onPopupApply = (data, kpiChanged) => {
    // kpiChanged is not used as setSelectedMetrics is called everytime
    // saga listens to it and fetches data
    // axios cache is cleared if kpi changed
    if (!includes(data, appliedSort.metric) && data.length > 0) {
      dispatch(
        setAppliedSort({
          filter: 0,
          metric: data[0],
          order: 'desc',
        }),
      );
    }
    dispatch(setSelectedMetrics(data));
    track({ event: CLICK_ML_METRICS_CHANGE, data: { metrics: data } });
  };

  return (
    <DropdownWrapper>
      <MetricSelectorPopup
        supportedMetrics={supportedMetrics}
        selectedMetrics={selectedMetrics}
        onApply={onPopupApply}
      />
    </DropdownWrapper>
  );
};

export default MetricsDropDown;
